"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { VRHUMP_CATEGORIES } from "@/lib/vrhump-categories"
import { useTranslations } from "next-intl"

interface VrhumpFilterTabsProps {
  category: string
  onCategoryChange: (value: string) => void
}

// VRHump's categories, from the site's own category list; see lib/booru-sources/booru-api/vrhump.ts.
export function VrhumpFilterTabs({ category, onCategoryChange }: VrhumpFilterTabsProps) {
  const t = useTranslations("vrhumpFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[{ id: "category", label: t("category"), value: category, defaultValue: "all", options: [{ value: "all", label: t("allCategories") }, ...VRHUMP_CATEGORIES.map((c) => ({ value: c.id, label: c.label }))] }]}
      onChange={(_, value) => onCategoryChange(value)}
    />
  )
}
